import React from 'react';
import { resetPasswordSuccessStep as resetPasswordLocales } from 'globals/locales/registration';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import { ReactComponent as ResetSendIcon } from 'assets/images/reset-password/reset-send.svg';

const ResetPasswordSuccessStep: React.FC = () => {
  return (
    <FsAlertBoard
      title={resetPasswordLocales.title}
      maxWidth={440}
      icon={<ResetSendIcon />}
    >
      {resetPasswordLocales.description}
    </FsAlertBoard>
  );
};

export default ResetPasswordSuccessStep;
